import axios from "axios";
import api from "./url";

axios.interceptors.request.use(async function (config) {
  const local_token = localStorage.getItem("token");
  config.headers.Authorization = `Bearer ${local_token}`;

  return config;
});

//-----------------------login------------------------------------
export const login = (data) => {
  return axios.post(api.login, data);
};

//-----------------------logout-----------------------------------
export const logout = () => {
  return axios.post(api.logout);
};

//-----------------------update admin data------------------------
export const update_admin_data = (data) => {
  return axios.post(api.admin_update, data);
};

//-----------------------user details-----------------------------
export const get_user_details = (data) => {
  return axios.post(api.user_details, data);
};

//-----------------------user add-------------------------------
export const add_user_api = (data) => {
  return axios.post(api.add_user, data);
};

//-----------------------user delete-----------------------------
export const user_delete_api = (id) => {
  return axios.post(api.user_delete, { user_id: id });
};

//-----------------------user update-----------------------------
export const user_update_api = (data) => {
  return axios.post(api.user_update, data);
};

//-----------------------state details---------------------------
export const state_details_api = () => {
  return axios.get(api.state_details);
};

//-----------------------city details----------------------------
export const city_details_api = (data) => {
  return axios.post(api.city_details, data);
};

//-----------------------city add-------------------------------
export const add_city_api = (data) => {
  return axios.post(api.add_city, data);
};

//-----------------------city delete-----------------------------
export const city_delete_api = (id) => {
  return axios.post(api.city_delete, { city_id: id });
};

//-----------------------city update-----------------------------
export const city_update_api = (data) => {
  return axios.post(api.city_update, data);
};

// ----------------add area -------------
export const add_area_api = (data) => {
  return axios.post(api.add_area, data);
};

// ----------------update area -------------
export const update_area_api = (data) => {
  return axios.post(api.area_update, data);
};

// -----------  area details ------------
export const area_details_api = (data) => {
  return axios.post(api.area_details, data);
};

// -----------  area delete ------------
export const area_delete_api = (id) => {
  return axios.post(api.area_delete, { area_id: id });
};

//-----------------------get product-----------------------------
export const fetch_product = () => {
  return axios.get(api.get_product);
};

//-----------------------add product-----------------------------
export const add_product_api = (data) => {
  return axios.post(api.add_product, data);
};

//-----------------------update product--------------------------
export const update_product_api = (data) => {
  return axios.post(`${api.update_product}`, data);
};

//-----------------------get stock-----------------------------
export const fetch_stock = () => {
  return axios.get(api.get_stock);
};

//-----------------------update stock--------------------------
export const update_stock_api = (data) => {
  return axios.post(`${api.update_stock}`, data);
};

//-----------------------get user rights-----------------------------
export const fetch_user_rights = (id) => {
  return axios.post(api.get_user_rights, { user_id: id });
};

//-----------------------update user rights--------------------------
export const update_user_rights_api = (data) => {
  return axios.post(`${api.update_user_rights}`, data);
};

//-----------------------orders-----------------------------
export const fetch_orders = (data) => {
  return axios.post(api.order_list, data);
};

export const fetch_sub_orders = (data) => {
  return axios.post(api.sub_order_list, data);
};

export const sub_order_update = (data) => {
  return axios.post(api.update_sub_order, data);
};

export const get_order_details = (data) => {
  return axios.post(api.order_details, data);
};

//-----------------------filed orders-----------------------------
export const fetch_failed_orders = (data) => {
  return axios.post(api.failed_orders, data);
};

//-----------------------transfer order-----------------------------
export const transfer_order = (data) => {
  return axios.post(api.transfer, data);
};

//-----------------------dashboard-----------------------------
export const dashboard_count = () => {
  return axios.get(api.dashboard_count);
};

// -----------------policies----------------
export const policy_details = (data) => {
  return axios.post(api.policy_details, data);
};
export const policy_update = (data) => {
  return axios.post(api.policy_update, data);
};

// -----------------dietician request list----------------
export const fetch_dietician_request_list = () => {
  return axios.get(api.dietician_request_list);
};
export const update_dietician_request_list = (data) => {
  return axios.post(api.dietician_request_list_update, data);
};



